
<div class="graphs-filter">

    <div class="graph-filter-container">
    <form #statForm="ngForm" class="graphs-filter-form">
      <div class="graphs-filter-content" *ngIf="elementsData">

        <div class="filter-item">
            <mat-radio-group   class="example-radio-group"  [(ngModel)]="filterValues.dateType" name="dateTypeGroup">
              <div class="range-date-time">
                <span class="flexItem title">Date</span>
                <mat-radio-button class="example-radio-button" [value]="'RANGE'" color="primary">
                  Date range:
                </mat-radio-button>
                <div class="time-range-date-picker-stat">
                <ac-date-picker
                                [acModel]="filterValues.date"
                               (acChanged)="filterValues.date = $event"
                                startModelName="startDate"
                                endModelName="endDate"
                                openDirection="down"
                                [options]="datePickerOptions"
                                [ngDisabled]="!isRangeSelected()">
                </ac-date-picker>
                </div>
              </div>
              <div>

                <mat-radio-button class="relative-time-radio-button" color="primary" [value]="'RELATIVE'">
                  Date relative time:
                </mat-radio-button>

              </div>

                <div class="relative-time" >

                  <div class="relative-time-label-wrapper">
                    <label class="relative-time-label">Last:</label>
                  </div>
                  <div class="relative-time-spinner-wrapper">
                  <mat-form-field class="relative-time-spinner" name="relativeTimeSpinnerInput">
                    <input type="number" matInput [(ngModel)]="filterValues.relativeTimeUnitValue" [min]="1" [max]="1000"
                           [disabled]="isRangeSelected()" name="relativeTimeUnitValueName" >
                  </mat-form-field>
                  </div>

                  <div class="relative-time-unit-wrapper">
                    <ac-input-container label="Range"   >
                      <ac-select
                               [(acModel)]="filterValues.relativeTimeUnit"
                               [items]="filterValues.timeUnitOptions"
                               [multiple]="false"
                               [allowClear]="false"
                               [bindValue]="'value'"
                               [bindLabel]="'name'"
                               [ngDisabled]="isRangeSelected()" >
                    </ac-select>
                  </ac-input-container>
                  </div>
                </div>


            </mat-radio-group>

        </div>

        <div class="filter-item" *ngIf="isSingleStatisticFilterSupported()">
          <span  class="flexItem title">Statistics</span>
          <div class="filter-item">
            <mat-form-field class="filter-item-container" >
              <mat-label>Type</mat-label>
              <mat-select [(ngModel)]="filterValues.singleStatistic" name="statType">
                <mat-option *ngFor="let item of filterValues.statisticsOptions" [value]="item.value">
                  {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>


        <div class="filter-item" *ngIf="isQuotaStatisticsElementsSupported()">
          <mat-form-field class="filter-item-container" >
            <mat-label>Quota name</mat-label>
            <mat-select [(ngModel)]="filterValues.quotaElementId" name="statQuata">
              <mat-option *ngFor="let item of filterValues.quotaElementsOptions" [value]="item.id">
                {{item.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="filter-item" *ngIf="isQuotaStatisticsElementsSupported()">
          <mat-form-field class="filter-item-container" >
            <mat-label>Quota element type</mat-label>
            <mat-select [(ngModel)]="filterValues.quotaElementType" name="statQuotaElementType">
              <mat-option *ngFor="let item of filterValues.quotaTypesOptions" [value]="item.id">
                {{item.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="filter-item" *ngIf="isMultipleStatisticsFilterSupported()">
          <span  class="flexItem title">Statistics</span>
          <ac-input-container label="Type" >
          <ac-select class="single-row" name="statTypeMulti"
                     [(acModel)]="filterValues.multipleStatistics"
                     (acModelChange)="filterValues.multipleStatistics = $event;"
                     [items]="filterValues.statisticsOptions"
                     [multiple]="true"
                     [allowClear]="true"
                     [bindValue]="'value'"
                     [bindLabel]="'name'">
          </ac-select>
          </ac-input-container>
        </div>

        <div class="filter-item" *ngIf="isNumberOfElementsFilterSupported()">
          <mat-form-field class="filter-item-container" >
            <mat-label>Number of elements</mat-label>
            <input type="number" matInput [(ngModel)]="filterValues.numberOfElements" [min]="1" [max]="50" name="statNumOfElements">
          </mat-form-field>
        </div>



      <div class="filter-item" *ngIf="isNumberOfStackedElementsFilterSupported()">
        <mat-form-field class="filter-item-container" >
        <mat-label>Number of stacked elements</mat-label>
        <input type="number" matInput [(ngModel)]="filterValues.numberOfStackedElements" [min]="1" [max]="50" name="statNumOfStackElements">
        </mat-form-field>
      </div>


        <div class="filter-item" *ngIf="isElementsFilterSupported()">
          <ac-input-container label="Elements" >
          <ac-select class="single-row" name="statElements"
                     [(acModel)]="filterValues.elements"
                     (acModelChange)="filterValues.elements = $event;"
                     [items]="elementOptions"
                     [multiple]="true"
                     [allowClear]="true"
                     [bindValue]="'id'"
                     [bindLabel]="'name'"
                     [groupBy]="'parentName'">
          </ac-select>
          </ac-input-container>
        </div>


        <div class="filter-item" *ngIf="isSingleElementFilterSupported()">
          <ac-input-container label="Element" >
            <ac-select class="single-row" name="statElement"
                       [(acModel)]="filterValues.element"
                       [items]="elementOptions"
                       [bindValue]="'id'"
                       [bindLabel]="'name'"
                       [groupBy]="'parentName'">
            </ac-select>
          </ac-input-container>
        </div>
      </div>


          <div class="filter-search-button">
            <button class="search-button" mat-raised-button
                color="primary" (click)="onSubmit(reportIdentifier, filterValues)"
                [disabled]="!isSubmitButtonEnabled() || !statForm.form.valid">Submit</button>
          </div>
    </form>
    </div>


</div>

